import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import customTheme, { FONT_SIZES } from '@/theme'

const useStyles = makeStyles((theme) => ({
  container: ({ size }) => {
    return {
      width: size,
      height: size,
      position: 'relative',
      '& *': {
        boxSizing: 'border-box',
      },
    }
  },
  fullSize: {
    width: '100%',
    height: '100%',
  },
  label: ({ fontSize }) => {
    return {
      fontSize,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  },
  circle: ({ progress, size }) => {
    return {
      position: 'absolute',
      left: 0,
      top: 0,
      clip: progress <= 50 ? `rect(0, ${size}px, ${size}px, ${size / 2}px)` : 'rect(auto, auto, auto, auto)',
    }
  },
  leftSide: ({ progress }) => {
    return {
      transform: `rotate(${progress * 3.6}deg)`,
    }
  },
  rightSide: ({ progress }) => {
    if (progress <= 50) {
      return {
        display: 'none',
      }
    } else {
      return {
        transform: 'rotate(180deg)',
      }
    }
  },
  halfCircle: ({ borderColor, borderWidth, size }) => {
    return {
      border: `${borderWidth}px solid ${borderColor}`,
      borderRadius: '50%',
      clip: `rect(0, ${size / 2}px, ${size}px, 0)`,
      position: 'absolute',
      left: 0,
      top: 0,
    }
  },
  shadow: ({ borderWidth }) => {
    return {
      border: `${borderWidth}px solid ${theme.borderColor}`,
      borderRadius: '50%',
    }
  },
}))

const ProgressCircle = props => {
  const { borderColor, borderWidth, size, progress, fontSize, customClass } = props
  const classes = useStyles({ borderColor, borderWidth, size, progress, fontSize })

  return (
    <div className={clsx(classes.container, customClass)}>
      <div className={clsx(classes.label, classes.fullSize)}>{progress}%</div>
      <div className={clsx(classes.circle, classes.fullSize)}>
        <div className={clsx(classes.leftSide, classes.halfCircle, classes.fullSize)}></div>
        <div className={clsx(classes.rightSide, classes.halfCircle, classes.fullSize)}></div>
      </div>
      <div className={clsx(classes.shadow, classes.fullSize)}></div>
    </div>
  )
}

ProgressCircle.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  fontSize: PropTypes.string,
  size: PropTypes.number,
  progress: PropTypes.number,
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

ProgressCircle.defaultProps = {
  borderColor: customTheme.lighterBlue,
  borderWidth: 3,
  fontSize: FONT_SIZES.smaller,
  progress: 0,
  size: 40,
}

export default ProgressCircle
